import api from './api';

/**
 * Serviço para gerenciar configurações de credenciais
 */
export const credencialConfigService = {
  /**
   * Listar cursos que possuem templates de credenciais
   */
  listarCursos: async () => {
    try {
      const response = await api.get('/credencial-config/cursos');
      return response.data;
    } catch (error) {
      console.error('Erro ao listar cursos:', error);
      throw error;
    }
  },

  /**
   * Obter configuração de um curso específico
   */
  obterConfig: async (sigla) => {
    try {
      const response = await api.get(`/credencial-config/${sigla}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao obter configuração:', error);
      throw error;
    }
  },

  /**
   * Salvar configuração de um curso
   */
  salvarConfig: async (sigla, config) => {
    try {
      const response = await api.put(`/credencial-config/${sigla}`, config);
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar configuração:', error);
      throw error;
    }
  },

  /**
   * Upload de template de credencial
   */
  uploadTemplate: async (sigla, file, lado) => {
    try {
      const formData = new FormData();
      formData.append('template', file);
      
      // Envia o lado via query parameter para o multer ter acesso
      const response = await api.post(`/credencial-config/${sigla}/template?lado=${lado}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao fazer upload do template:', error);
      throw error;
    }
  },

  /**
   * Criar novo template para um curso
   */
  criarTemplate: async (sigla) => {
    try {
      const response = await api.post(`/credencial-config/${sigla}/criar`);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar template:', error);
      throw error;
    }
  },

  /**
   * Obter URL do template
   */
  getTemplateUrl: (sigla, lado) => {
    const baseUrl = api.defaults.baseURL || '';
    return `${baseUrl}/credencial-config/${sigla}/template/${lado}`;
  }
};

export default credencialConfigService;
